import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer-container'>
        
        <div className="grid">

          <div className="footer-headings" id='f-about'>
            <h3>BookWorm.in</h3>

            <ul>
              <li><i className="fa-solid fa-location-dot"></i> Dehradun, Uttrakhand</li>
              <li><a href='tel:+911234567890'><i className="fa-solid fa-phone"></i> +91 1234567890</a></li>
              <li><a><i className="fa-solid fa-envelope"></i> BookWormCustomerCare@gmail.com</a></li>
            </ul>
            
          </div>

          <div className="footer-headings" id='f-collections'>
            <h3>Collections</h3>
            <ul>
              <li><a>Buisness</a></li>
              <li><a>Science</a></li>
              <li><a>Finance</a></li>
              <li><a>Fiction</a></li>
            </ul>
          </div>

          <div className='footer-headings' id='f-socials'>
            <h3>Socials</h3>

            <ul>
                <li><i className="fa-brands fa-facebook-f"></i><a href='/'>Facebook</a></li>
                <li><i className="fa-brands fa-instagram"></i><a href='/'>Instagram</a></li>
                <li><i className="fa-brands fa-linkedin-in"></i><a href='/'>Linkedin</a></li>
            </ul>
          </div>

          <div className="footer-headings" id='f-quickLinks'>
            <h3>Quick Links</h3>
            <ul>
              <li><a>Post an Ad</a></li>
              <li><a>Terms and Condition</a></li>
              <li><a>Safety Tips</a></li>
              <li><a>Privacy Policy</a></li>
              <li><Link to='/developersInfo'>Developers Info</Link></li>
            </ul>
          </div>
          
        </div>
        
    </div>
  )
}

export default Footer